import { checkResponse } from "../utils/checkResponse";
import { DomainAPI, Channel, getHeader, _pick } from "../utils/setting";

const memberCard = {
  state: {
    total: 0,
    count: 0,
    listMemberCard: [],
    imgCardUrl: "",
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: {
    async create(payload, rootState) {
      const url = `${DomainAPI}${Channel}/api/secure/memberCards/create`;
      return await fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(
          _pick(payload, [
            "arrBranch",
            "title",
            "isShow",
            "price",
            "value",
            "shortDescription",
            "description",
            "image",
            "expiredDays",
            "times",
            "type",
            "forAll",
          ])
        ),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    getList(payload, rootState) {
      const _this = this;
      let url = `${DomainAPI}${Channel}/api/secure/memberCards/getList`;
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(
          _pick(payload, ["limit", "page", "search", "branchCode"])
        ),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            _this.setState({
              listMemberCard: res.data.list,
              total: res.data.total,
              count: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          console.log(err);
          return { code: 0, error: err, message: err.toString() };
        });
    },
    update(payload, rootState) {
      let url = `${DomainAPI}${Channel}/api/secure/memberCards/update`;
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(
          _pick(payload, [
            "_id",
            "arrBranch",
            "title",
            "isShow",
            "price",
            "value",
            "shortDescription",
            "description",
            "image",
            "expiredDays",
            "times",
            "type",
            "forAll",
          ])
        ),
      })
        .then((res) => res.json())
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    deleteById(payload, rootState) {
      let url = `${DomainAPI}${Channel}/api/secure/memberCards/deleteById`;
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(_pick(payload, ["ids"])),
      })
        .then((res) => res.json())
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  },
};

export default memberCard;
